export const trendFilter = {
  nav: 'Filtro de Tendencias',
  pageTitle: 'Filtro de Tendencias',
  common: {
    loadError: 'No se pudo cargar esta ejecución. Volvé a intentar.',
    backToHistory: 'Volver a ejecuciones',
    newRun: 'Nueva ejecución',
    viewHistory: 'Ver ejecuciones',
    retry: 'Reintentar',
  },
  launch: {
    title: 'Filtro de oportunidades de tendencia',
    subtitle:
      'Ramificá palabras semilla en consultas en alza de Google Trends, filtrá el ruido contra el contexto de negocio del cliente y mostrá solo oportunidades accionables.',
    seeds: {
      label: 'Palabras semilla',
      placeholder: 'Escribí una palabra y presioná Enter',
      hint: '{{count}} de {{max}} semillas',
      add: 'Agregar semilla',
      removeAria: 'Quitar semilla {{seed}}',
      duplicate: 'Esa semilla ya está agregada',
    },
    location: {
      label: 'Mercado',
      placeholder: 'Elegí un país',
      searchPlaceholder: 'Buscar país',
      noResults: 'Ningún país coincide',
    },
    language: {
      label: 'Idioma',
    },
    submit: 'Buscar oportunidades',
    submitting: 'Iniciando…',
    contextGate: {
      title: 'Completá primero el contexto del cliente',
      description:
        'El filtro necesita el contexto de negocio del cliente para distinguir tendencias relevantes del ruido. Completá los campos faltantes y luego iniciá la ejecución.',
      missingFieldsLabel: 'Campos faltantes',
      cta: 'Ir a configuración de empresa',
      dismiss: 'Descartar',
    },
    errors: {
      seedCap: 'Podés agregar como máximo {{max}} semillas por ejecución',
      atLeastOneSeed: 'Agregá al menos una palabra semilla',
      queueUnavailable: 'La cola de procesamiento no está disponible ahora. Probá en un momento.',
      generic: 'No se pudo iniciar la ejecución. Volvé a intentar.',
    },
  },
  wait: {
    title: 'Buscando oportunidades',
    subtitle:
      'Esto suele tardar uno o dos minutos. Podés salir de esta página y volver — la ejecución continúa.',
    leaveHint: 'Podés salir — seguimos procesando en segundo plano.',
    phases: {
      branching: {
        label: 'Ramificando semillas',
        description: 'Expandiendo semillas en consultas en alza de Google Trends.',
      },
      filtering: {
        label: 'Filtrando relevancia',
        description: 'Puntuando cada candidato contra el contexto de negocio del cliente.',
      },
      detecting: {
        label: 'Detectando contenido existente',
        description: 'Verificando si el cliente ya cubre cada tema.',
      },
    },
    cancel: 'Cancelar ejecución',
    cancelling: 'Cancelando…',
    partial: {
      title: 'Terminó con resultados parciales',
      description: 'Algunas semillas no se procesaron, pero encontramos oportunidades en el resto.',
      viewResults: 'Ver oportunidades',
    },
    failed: {
      title: 'La ejecución falló',
      description: 'No pudimos completar esta ejecución. Podés iniciar una nueva con las mismas semillas.',
    },
    emptyCompleted: {
      title: 'Sin señales accionables',
      description: 'El filtro se ejecutó pero no encontró tendencias en alza relevantes para estas semillas.',
    },
  },
  dashboard: {
    title: 'Oportunidades',
    resultsSummary: '{{kept}} conservadas de {{total}} candidatos',
    searchPlaceholder: 'Buscar temas',
    columns: {
      topic: 'Tópico',
      trend: 'Tendencia relativa',
      reason: 'Por qué',
      existingContent: '¿Ya tenés contenido?',
      action: 'Acción recomendada',
      plan: 'Agregar al plan',
      controls: '',
    },
    trendTooltip: 'Posición relativa (1–100), no volumen de búsqueda.',
    reasonEmpty: 'Sin motivo provisto',
    actionLabels: {
      create: 'Crear',
      update: 'Actualizar',
      review: 'Revisar',
    },
    existingStatusLabels: {
      none: 'Sin contenido existente',
      exists: 'Ya cubierto',
      stale: 'Cubierto pero desactualizado',
      unknown: 'Desconocido',
      ambiguous: 'Coincidencia ambigua',
    },
    matchedOn: 'Actualizado {{date}}',
    noMatchDate: 'Sin fecha',
    viewContent: 'Ver contenido',
    pin: 'Fijar',
    unpin: 'Desfijar',
    hide: 'Ocultar',
    unhide: 'Mostrar',
    showNoise: 'Ver descartadas (ruido)',
    hideNoise: 'Ocultar descartadas',
    viewStateError: 'No se pudo actualizar la oportunidad. Volvé a intentar.',
    addToPlan: 'Agregar al plan',
    viewInPlan: 'En el plan',
    addToPlanSuccess: 'Agregado a «{{plan}}»',
    alreadyInPlan: 'Ya está en «{{plan}}»',
    addToPlanError: 'No se pudo agregar al plan de contenido. Volvé a intentar.',
    planPicker: {
      title: 'Elegí un plan de contenido',
      description: '¿A qué plan agregar «{{topic}}»?',
      itemCount: '{{count}} ítems',
    },
    empty: {
      title: 'Sin señales accionables',
      description:
        'El filtro no encontró oportunidades relevantes. Podés revisar lo que se descartó como ruido.',
    },
    emptyNoise: {
      title: 'Nada descartado',
      description: 'No se filtraron candidatos como ruido en esta ejecución.',
    },
  },
  detail: {
    seedLabel: 'Desde la semilla «{{seed}}»',
    chartTitle: 'Tendencia relativa',
    chartValueLabel: 'Posición relativa',
    chartError: 'No se pudo cargar la serie de tendencia.',
    chartEmpty: 'Sin datos de tendencia para este período.',
    reasonTitle: 'Por qué es relevante',
    periods: {
      oneMonth: '1M',
      threeMonths: '3M',
      sixMonths: '6M',
      twelveMonths: '12M',
    },
  },
  history: {
    title: 'Ejecuciones de tendencias',
    subtitle: 'Ejecuciones previas del filtro de tendencias para esta organización.',
    columns: {
      seeds: 'Semillas',
      status: 'Estado',
      kept: 'Conservadas',
      created: 'Iniciada',
      actions: '',
    },
    statusLabels: {
      pending: 'Pendiente',
      running: 'En curso',
      completed: 'Completada',
      partial: 'Parcial',
      failed: 'Fallida',
    },
    open: 'Abrir',
    rerun: 'Re-ejecutar mismas semillas',
    delete: 'Eliminar',
    deleteConfirm: {
      title: '¿Eliminar esta ejecución?',
      description: 'Esto elimina de forma permanente la ejecución y sus oportunidades. No se puede deshacer.',
      confirm: 'Eliminar',
      cancel: 'Cancelar',
    },
    deleteSuccess: 'Ejecución eliminada',
    deleteError: 'No se pudo eliminar la ejecución. Volvé a intentar.',
    seedsMore: '+{{count}} más',
    empty: {
      title: 'Todavía no hay ejecuciones',
      description: 'Iniciá tu primera ejecución del filtro de tendencias para descubrir oportunidades en alza.',
      cta: 'Nueva ejecución',
    },
  },
} as const
